import { render, staticRenderFns } from "./ReferenceFileDownloadList.vue?vue&type=template&id=4b0adb29&"
import script from "./ReferenceFileDownloadList.vue?vue&type=script&lang=js&"
export * from "./ReferenceFileDownloadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItemGroup})
